import { type PayloadAction, type Slice, createSlice } from "@reduxjs/toolkit"
// eslint-disable-next-line import/no-extraneous-dependencies
import type { WritableDraft } from "immer"
import isEqual from "lodash-es/isEqual"

// The types module directly, not the "../ui" barrel. That barrel also re-exports ui.config, which
// reaches "@/3514/components" and through it the whole component tree — and this slice is imported
// by the root store, so it would place every component inside store initialisation. A reducer has no
// business depending on UI modules in the first place; these two are an enum and a type.
import {
    EParticipantHeaderVariant,
    EParticipantHeaderVariant as EVariant,
    type TModuleExcerptModelToRender
} from "../ui/participant.header.ui.types"

const PARTICIPANT_HEADER_REDUCER_NAME: string = "participantHeader"

interface IParticipantHeaderState {
    config: {
        withNextSessionBlock?: boolean
        withJourneyAchievementsBlock?: boolean
        withModuleExcerptsBlock?: boolean
        isVisible?: boolean
        variant?: EVariant
    }
    excerpts: TModuleExcerptModelToRender[]
}

const initialState: IParticipantHeaderState = {
    config: {
        withNextSessionBlock: false,
        withModuleExcerptsBlock: false,
        withJourneyAchievementsBlock: false,
        isVisible: false,
        variant: EParticipantHeaderVariant.Dashboard
    },
    excerpts: []
}

const slice: Slice = createSlice({
    name: PARTICIPANT_HEADER_REDUCER_NAME,
    initialState,
    reducers: {
        configSetter(
            state: WritableDraft<IParticipantHeaderState>,
            action: PayloadAction<Pick<IParticipantHeaderState, "config">["config"]>
        ): void {
            if (!isEqual(state.config, action.payload)) state.config = action.payload
        },
        excerptsSetter(
            state: WritableDraft<IParticipantHeaderState>,
            action: PayloadAction<Pick<IParticipantHeaderState, "excerpts">["excerpts"]>
        ): void {
            state.excerpts = action.payload
        },
        resetState(): IParticipantHeaderState {
            return initialState
        }
    }
})

const { reducer: participantHeaderReducer, actions: participantHeaderReducerActions }: Slice = slice

export { participantHeaderReducer, participantHeaderReducerActions, PARTICIPANT_HEADER_REDUCER_NAME }
export type { IParticipantHeaderState }
